export const POLISHING_DAMAGE_REQUEST = "POLISHING_DAMAGE_REQUEST";
export const POLISHING_DAMAGE_SUCCESS = "POLISHING_DAMAGE_SUCCESS";
export const POLISHING_DAMAGE_FAILED = "POLISHING_DAMAGE_FAILED";